const DEFAULT_TRADING_STYLE_BADGE = 'bg-slate-800/60 text-slate-200 border-slate-600/40';

const TRADING_STYLE_BADGE_PALETTE = [
  'bg-sky-500/10 text-sky-300 border-sky-500/30',
  'bg-violet-500/10 text-violet-300 border-violet-500/30',
  'bg-rose-500/10 text-rose-300 border-rose-500/30',
  'bg-emerald-500/10 text-emerald-300 border-emerald-500/30',
  'bg-amber-500/10 text-amber-300 border-amber-500/30',
  'bg-cyan-500/10 text-cyan-300 border-cyan-500/30',
  'bg-indigo-500/10 text-indigo-300 border-indigo-500/30',
  'bg-fuchsia-500/10 text-fuchsia-300 border-fuchsia-500/30',
  'bg-teal-500/10 text-teal-300 border-teal-500/30',
  'bg-orange-500/10 text-orange-300 border-orange-500/30',
  'bg-lime-500/10 text-lime-300 border-lime-500/30',
  'bg-blue-500/10 text-blue-300 border-blue-500/30'
];

const hashString = (value) => {
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = (hash * 31 + value.charCodeAt(i)) | 0;
  }
  return Math.abs(hash);
};

export const getTradingStyleBadgeClass = (style) => {
  if (!style) return DEFAULT_TRADING_STYLE_BADGE;
  const key = String(style).trim().toLowerCase();
  if (!key) return DEFAULT_TRADING_STYLE_BADGE;
  if (key.includes('高频') || key.includes('hft') || key.includes('high frequency') || key.includes('量化')) {
    return 'bg-sky-500/10 text-sky-300 border-sky-500/30';
  }
  if (key.includes('套利') || key.includes('arbitrage') || key.includes('做市') || key.includes('market maker') || key.includes('market-making')) {
    return 'bg-violet-500/10 text-violet-300 border-violet-500/30';
  }
  if (key.includes('趋势') || key.includes('动量') || key.includes('momentum') || key.includes('trend')) {
    return 'bg-rose-500/10 text-rose-300 border-rose-500/30';
  }
  if (key.includes('稳健') || key.includes('保守') || key.includes('低频') || key.includes('价值') || key.includes('hold')) {
    return 'bg-emerald-500/10 text-emerald-300 border-emerald-500/30';
  }
  const index = hashString(key) % TRADING_STYLE_BADGE_PALETTE.length;
  return TRADING_STYLE_BADGE_PALETTE[index];
};
